import React, { useContext, useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Button,
  Badge,
  Box,
  CircularProgress
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import notificheApi from '../../api/notificheApi';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

export default function NotificheListPageMobile() {
  const [notifiche, setNotifiche] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchNotifiche();
  }, []);

  const fetchNotifiche = async () => {
    setLoading(true);
    try {
      const r = await notificheApi.lista();
      setNotifiche(r);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (notifica) => {
    setLoading(true);
    try {
      if (!notifica.letta) {
        await notificheApi.markAsRead(notifica.id);
        await fetchNotifiche();
      }

      switch (notifica.tipoNotifica) {
        case 'DOCUMENTO_RICHIESTO':
          navigate(`/fascicolo/me`);
          break;
        case 'DOCUMENTO_CARICATO':
          if (notifica.contribuenteId) {
            user.role !== 'CONTRIBUENTE'
              ? navigate(`/fascicolo/contribuente/${notifica.contribuenteId}`)
              : navigate(`/fascicolo/me`);
          }
          break;
        default:
          console.warn('Tipo notifica non gestito:', notifica.tipoNotifica);
      }
    } catch (err) {
      console.error('Errore gestione notifica', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container sx={{ mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Notifiche
      </Typography>

      {loading && notifiche.length === 0 ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : notifiche.length === 0 ? (
        <Typography>Nessuna notifica</Typography>
      ) : (
        <Stack spacing={2}>
          {notifiche.map((n) => (
            <Accordion key={n.id}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                  <Typography>{n.titolo}{" Inviata il:  "+formatDate(n.dataCreazione)}</Typography>
                  {!n.letto && <Badge color="primary" badgeContent="Nuova" />}
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ mb: 1 }}>{n.messaggio}</Typography>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleClick(n)}
                  fullWidth
                >
                  Vai alla notifica
                </Button>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      )}

      {loading && notifiche.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Container>
  );
}